module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/bed.svg?c356706a";